// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "chartkick"
import "chartkick/chart.js"

window.bootstrap = bootstrap

function initTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    if (!bootstrap.Tooltip.getInstance(el)) new bootstrap.Tooltip(el)
  })
}

document.addEventListener("turbo:load", initTooltips)
document.addEventListener("turbo:frame-load", initTooltips)
document.addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render
  event.detail.render = function(streamElement) {
    originalRender(streamElement)
    initTooltips()
  }
})

// A form or link inside a Turbo frame that gets redirected somewhere without that frame (the
// P&L limit page, a sign-in page) would otherwise show "Content missing" in the frame. Go there
// as a full page visit instead.
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})
